/* ====================================================================================================================
 * MEMBERSHIP SELECT  —  Shoplift API test "membership-select"
 * --------------------------------------------------------------------------------------------------------------------
 * Lógica del selector "Únete a Sin Intermediarios" (membresía) vs "Compra única" en la PDP (theme Impact).
 *
 * TIPO DE PRUEBA: API de Shoplift. Este archivo vive en el theme de PRODUCCIÓN (no hay theme duplicado). El markup
 * del selector se sirve a TODOS los visitantes pero nace oculto por CSS; aquí se consulta
 * shoplift.isHypothesisActive(HYPOTHESIS_ID) y SOLO si resuelve true se activa la variante B:
 *
 *   1. Se agrega la clase `sl-ms-active` a <html> → el CSS del snippet muestra el selector y oculta el price
 *      block del buy box.
 *   2. Se pone el flag `active` → recién entonces el interceptor del ATC, el relocate del DOM y el resto de los
 *      handlers hacen algo. Con `active === false` (variante A / control, o mientras la promesa no resuelve) TODOS
 *      los handlers salen de una y la PDP se comporta exactamente como en producción.
 *
 * El id se lee del atributo data-hypothesis-id que pone el snippet (una sola fuente de verdad:
 * snippets/membership-select.liquid → ms_hypothesis_id) y es el ID de la VARIANTE B en el panel de Shoplift.
 * Si sigue en el placeholder, se queda en control y avisa por consola.
 *
 * - Ubicación (híbrida, en product-info.liquid): en productos multi-variante el selector va en el case
 *   variant_picker (justo después de las variantes); en productos de variante única (variant_picker con
 *   disabled:true, ej. gomitas/cápsulas) cae como fallback al bloque buy_buttons. Así siempre aparece y queda
 *   pegado a las variantes cuando existen.
 * - Precios: los renderiza Liquid (money_with_currency → "$… COP"). En multi-variante el bloque variant_picker
 *   se re-renderiza al cambiar de variante, trayendo los precios nuevos ya formateados; el JS solo restaura la
 *   elección join/once (que ese re-render resetea).
 * - Delegación de eventos: todo va delegado a document (change / variant:change / submit).
 * - Add to cart (Únete): se intercepta el submit del product-form en captura; se agrega membresia-anual al carrito
 *   (si no está ya) y se re-dispara el submit normal del theme para el producto principal (que abre el drawer).
 *   El 10% lo aplica un automatic discount de Shopify cuando membresia-anual está en el carrito.
 * ==================================================================================================================== */
(function () {
  'use strict';

  // Idempotencia: por seguridad evitamos duplicar los listeners si el script se cargara más de una vez.
  if (window.__membershipSelectInit) return;
  window.__membershipSelectInit = true;

  var SELECTED_CLASS = 'is-selected';
  var ACTIVE_CLASS = 'sl-ms-active';
  var PLACEHOLDER_ID = 'REEMPLAZAR-CON-HYPOTHESIS-ID';
  var TEST_NAME = 'membership-select';

  // Gate de la prueba API: mientras sea false, TODOS los handlers de abajo son no-ops y la PDP queda intacta
  // (variante A / control). Solo lo pone en true la resolución de isHypothesisActive().
  var active = false;

  // Recuerda la elección (join/once) por form id. En multi-variante el selector vive en el bloque variant_picker,
  // que se re-renderiza al cambiar de variante (reseteando el radio al default "once"): en variant:change la
  // restauramos, así el usuario que eligió "Únete" no la pierde al cambiar de sabor/tamaño.
  var choiceByForm = {};

  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function escapeAttr(value) {
    return (window.CSS && CSS.escape) ? CSS.escape(value) : String(value).replace(/"/g, '\\"');
  }

  function selectorsForForm(formId) {
    if (!formId) return [];
    return Array.prototype.slice.call(
      document.querySelectorAll('membership-select[form="' + escapeAttr(formId) + '"]')
    );
  }

  function applySelectedState(ms) {
    var opts = ms.querySelectorAll('.ms-option');
    for (var i = 0; i < opts.length; i++) {
      var input = opts[i].querySelector('input[type="radio"]');
      opts[i].classList.toggle(SELECTED_CLASS, !!(input && input.checked));
    }
  }

  function currentChoice(ms) {
    var checked = ms.querySelector('input[type="radio"]:checked');
    // Fallback 'once' = el default del markup: si por lo que sea no hay ningún radio marcado, el ATC NO debe
    // agregar la membresía a espaldas del usuario.
    return checked ? checked.value : 'once';
  }

  function restoreChoice(ms) {
    var want = choiceByForm[ms.getAttribute('form')];
    if (want) {
      var input = ms.querySelector('input[type="radio"][value="' + want + '"]');
      if (input && !input.checked) input.checked = true;
    }
    applySelectedState(ms);
  }

  /* --- Cambio de radio (delegado): recuerda y resalta la opción; el CSS colapsa/expande los beneficios. --- */
  document.addEventListener('change', function (e) {
    if (!active) return;
    var radio = e.target;
    if (!radio || !radio.classList || !radio.classList.contains('ms-option__radio')) return;
    var ms = radio.closest('membership-select');
    if (!ms) return;
    choiceByForm[ms.getAttribute('form')] = radio.value;
    applySelectedState(ms);
  });

  /* --- variant:change: en multi-variante el selector vive en el bloque variant_picker, que el theme
   *     re-renderiza (los precios nuevos ya vienen correctos desde Liquid) reseteando el radio al default
   *     "once". Restauramos la elección del usuario. --- */
  document.addEventListener('variant:change', function (e) {
    if (!active) return;
    var form = (e.target && e.target.closest) ? (e.target.closest('form') || e.target) : e.target;
    var formId = (form && form.getAttribute) ? form.getAttribute('id') : null;
    var list = formId
      ? selectorsForForm(formId)
      : Array.prototype.slice.call(document.querySelectorAll('membership-select'));
    for (var i = 0; i < list.length; i++) restoreChoice(list[i]);
  });

  /* --- Add to cart: intercepto el submit del product-form en fase de CAPTURA (corre antes que ProductForm).
   *     En la variante A este handler sale en la primera línea: el ATC del theme funciona sin tocarse. --- */
  document.addEventListener('submit', function (e) {
    if (!active) return;
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var formId = form.getAttribute('id');
    if (!formId) return;

    var list = selectorsForForm(formId);
    if (!list.length) return;
    var ms = list[0];

    // Segundo paso (passthrough): dejamos que el theme haga su flujo normal (agrega el producto + abre drawer).
    if (form.__msPassthrough) { form.__msPassthrough = false; return; }

    // Si "Únete" no está activo -> comportamiento normal (compra única, solo el producto).
    if (currentChoice(ms) !== 'join') return;

    // Tomamos el control: primero membresía, luego re-disparamos el submit normal del theme.
    e.preventDefault();
    e.stopImmediatePropagation();

    if (form.__msBusy) return;
    form.__msBusy = true;

    var submitter = (e.submitter && form.contains(e.submitter)) ? e.submitter : null;

    ensureMembershipInCart(ms)
      .catch(function (err) {
        console.warn('[membership-select] no se pudo agregar la membresía:', err);
      })
      .then(function () {
        form.__msBusy = false;
        form.__msPassthrough = true;
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit(submitter || undefined);
        } else if (submitter) {
          submitter.click();
        } else {
          form.submit();
        }
      });
  }, true);

  function ensureMembershipInCart(ms) {
    var variantId = ms.getAttribute('data-membership-variant-id');
    var productId = ms.getAttribute('data-membership-product-id');
    // membresia-anual es una suscripción (requires_selling_plan): se DEBE agregar con su selling plan.
    var sellingPlan = ms.getAttribute('data-membership-selling-plan');
    if (!variantId) return Promise.reject(new Error('membership variant id ausente'));

    return fetch(root() + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var already = (cart.items || []).some(function (line) {
          return String(line.variant_id) === String(variantId) ||
                 String(line.product_id) === String(productId);
        });
        if (already) return null;

        var addItem = { id: parseInt(variantId, 10), quantity: 1 };
        if (sellingPlan) {
          addItem.selling_plan = parseInt(sellingPlan, 10);
        }

        return fetch(root() + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items: [addItem] })
        }).then(function (res) {
          if (!res.ok) {
            return res.json().catch(function () { return {}; }).then(function (err) {
              throw new Error((err.description || err.message || 'cart/add falló') + ' (HTTP ' + res.status + ')');
            });
          }
          return res.json();
        });
      });
  }

  /* --- En productos de variante única el selector cae como fallback dentro del bloque buy_buttons, que en el
   *     test pdp-simple está agrupado con quantity en un flex row → el selector saldría angosto y a la derecha.
   *     Lo sacamos de ese grupo y lo dejamos como fila full-width justo arriba del grupo quantity+ATC.
   *     Solo se llama en la variante B: en el control no se mueve nada del DOM. --- */
  function relocateFallback(ms) {
    var group = ms.closest('.shoplift-pdp-simple-qty-buy-group');
    if (group && group.parentNode) {
      group.parentNode.insertBefore(ms, group);
    }
  }

  /* ------------------------------------------------------------------------------------------------------------
   * Gate de Shoplift (prueba tipo API)
   * ---------------------------------------------------------------------------------------------------------- */

  // El script de Shoplift se inyecta en el <head> (snippets/shoplift.liquid) pero window.shoplift puede tardar
  // en existir. Mismo patrón de espera que snippets/shoplift-free-shipping-threshold.liquid: 50 × 100ms = 5s.
  function onShopliftReady(callback, onTimeout) {
    var maxAttempts = 50;
    var attempts = 0;
    (function check() {
      if (window.shoplift) {
        callback(window.shoplift);
      } else if (attempts < maxAttempts) {
        attempts++;
        setTimeout(check, 100);
      } else if (onTimeout) {
        onTimeout();
      }
    })();
  }

  function hypothesisId() {
    var el = document.querySelector('membership-select[data-hypothesis-id]');
    if (!el) return '';
    return (el.getAttribute('data-hypothesis-id') || '').trim();
  }

  function activateVariantB() {
    active = true;
    document.documentElement.classList.add(ACTIVE_CLASS);
    var all = document.querySelectorAll('membership-select');
    for (var i = 0; i < all.length; i++) {
      relocateFallback(all[i]);
      applySelectedState(all[i]);
    }
    console.log('Variant B - ' + TEST_NAME);
  }

  function stayInControl() {
    console.log('Variant A - ' + TEST_NAME);
  }

  function decide() {
    // Si el selector no se renderizó (miembro, PDP de la membresía, membresía no disponible en el mercado),
    // este script igual podría cargarse en el futuro: sin elemento no hay nada que decidir ni que loguear.
    if (!document.querySelector('membership-select')) return;

    var id = hypothesisId();
    if (!id || id === PLACEHOLDER_ID) {
      console.warn(
        '[membership-select] falta el HYPOTHESIS_ID de Shoplift. Pégalo en ' +
        'snippets/membership-select.liquid (assign ms_hypothesis_id). La prueba se queda en control.'
      );
      stayInControl();
      return;
    }

    onShopliftReady(function (shoplift) {
      if (!shoplift || typeof shoplift.isHypothesisActive !== 'function') {
        stayInControl();
        return;
      }
      Promise.resolve(shoplift.isHypothesisActive(id))
        .then(function (isActive) {
          if (isActive) {
            activateVariantB();
          } else {
            stayInControl();
          }
        })
        .catch(function () {
          stayInControl();
        });
    }, function () {
      // window.shoplift nunca apareció: no se puede decidir → control (fail-safe, la PDP queda como producción).
      console.warn('[membership-select] window.shoplift no está disponible; se queda en control.');
      stayInControl();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', decide);
  } else {
    decide();
  }
})();
